import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import {campaignRegister} from "../../services/campaignRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";

class SignupConfirmation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoadingButton: false,
            channels: null,
            currency: "",
            budget: null,
            plan: {},
            duration: null,
            vat: 0,
            lockin: null,
            landingpage: null,
            company_name: "",
            error: false,
            no_pay: false
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateData();

        //GOOGLE ANALYTICS
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactGA.pageview('/signup/confirmation');
            ReactGA4.send({ hitType: "pageview", page: "/signup/confirmation" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }
    }

    _updateData() {

        //TEMP
        let cart = cartRegister.get();

        let campaign = campaignRegister.get();
        if (campaign) {
            this.setState({
                channels: campaign.channels,
                campaign_fee: campaign.campaign_cost === 0 ? null : campaign.campaign_cost,
                vat: campaign.vat_percentage / 100,
                duration: campaign.duration,
                currency: campaign.currency,
                service_fee: campaign.service_fee === 0 ? null : campaign.service_fee,
                discount: campaign.discount > 0?campaign.discount:null,
                excess_credits: campaign.excess_credits > 0?campaign.excess_credits:null,
                id: campaign.campaign_id,
                lockin: campaign.lockin?campaign.lockin:0,
                plan: cart.plan,
                no_pay: campaign.no_pay ? campaign.no_pay : false
            }, () => {

                if (!campaign.no_pay) {
                    //GOOGLE EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactGA.event({category: 'User', action: 'Paid Campaign', value: this._renderPartialBudget()});
                        ReactGA4.event({category: 'User', action: 'Paid Campaign', value: this._renderPartialBudget()});
                    }

                    //FACEBOOK EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactPixel.track('Purchase', {value: this._renderPartialBudget(), currency: this.state.currency});
                    }
                } else {
                    //GOOGLE EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactGA.event({category: 'User', action: 'Created Payment Link', value: this._renderPartialBudget()});
                        ReactGA4.event({category: 'User', action: 'Created Payment Link', value: this._renderPartialBudget()});
                    }

                    //FACEBOOK EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactPixel.trackCustom('PaymentLink', {value: this._renderPartialBudget(), currency: this.state.currency});
                    }
                }


                if (campaign.discount > 0) {

                    //GOOGLE EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactGA.event({category: 'User', action: 'Redeemed Coupon', value: this.state.discount});
                        ReactGA4.event({category: 'User', action: 'Redeemed Coupon', value: this.state.discount});
                    }

                    //console.log("redeemed coupon amount: " + this.state.discount + this.state.currency);

                    //FACEBOOK EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactPixel.trackCustom('RedeemCoupon', {value: this.state.discount, currency: this.state.currency});
                    }

                } else if (campaign.excess_credits > 0) {

                    //GOOGLE EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactGA.event({category: 'User', action: 'Redeemed Coupon', value: this.state.excess_credits});
                        ReactGA4.event({category: 'User', action: 'Redeemed Coupon', value: this.state.excess_credits});
                    }

                    //console.log("redeemed coupon amount: " + this.state.excess_credits + this.state.currency);

                    //FACEBOOK EVENT
                    if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                        ReactPixel.trackCustom('RedeemCoupon', {value: this.state.excess_credits, currency: this.state.currency});
                    }

                }


                campaignRegister.remove();
                cartRegister.remove();
                imagesRegister.remove();
                quotesRegister.remove();
            });
        } else {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/signup/image");
        }
    }

    _myAccount() {
        try {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') +"/user/campaigns/running");
        } catch (error) {}
    }

    _renderPartialBudget() {
        if (this.state.channels) {
            let budget = 0;

            if(!this.state.campaign_fee){
                for (let key in this.state.channels) {
                    budget = budget + this.state.channels[key];
                }

                if (this.state.service_fee) {
                    budget = budget + this.state.service_fee;
                }
            }else{
                budget = budget + this.state.campaign_fee;
            }

            if (this.state.discount) {
                budget = budget - +this.state.discount;
            }

            if (this.state.excess_credits) {
                budget = budget - +this.state.excess_credits;
            }

            return budget;

        } else {
            return ("...");
        }
    }

    _renderDiscount(){
        let discount = 0;
        if(this.state.discount){
            discount = discount + +this.state.discount
        }
        if(this.state.excess_credits){
            discount = discount + +this.state.excess_credits
        }
        return discount;
    }

    _renderChannel(channel) {
        let item = channel;
        if (item === "fb") {
            item = "facebook"
        }
        if(item === "facebook"){
            return "Facebook social"
        }else if(item === "instagram"){
            return "Instagram social"
        }else if(item === "google"){
            return "Google search"
        }else if(item === "bing"){
            return "Bing search"
        }
    }

    _renderNumbers(x) {
        try {
            x = Math.round(x * 100) / 100;
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return (0)
        }
    }

    _renderText(item) {
        return langRegister.get("signup-confirmation", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne view={"signup"} props={this.props}/>
                {
                    this.state.channels && this.state.duration &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <span className={Styles.titleBold}>{this._renderText("item_1")}</span>{" "}
                            {
                                !this.state.no_pay &&
                                <span className={Styles.titleBoldGreen}>{this._renderText("item_3")}</span>
                            }
                            {
                                this.state.no_pay &&
                                <span className={Styles.titleBoldRed}>{this._renderText("item_27")}</span>
                            }
                        </div>
                        <div className={Styles.campaignId}>
                            {this._renderText("item_4")} <span
                            className={Styles.campaignIdNumber}>#{this.state.id}</span>
                        </div>
                        <div className={Styles.divider}/>
                        <div onClick={() => this._myAccount()} className={cx(Styles.button, Styles.buttonBlack)}>
                            {this._renderText("item_11")}
                        </div>
                        <div className={Styles.divider}/>
                        <div className={Styles.contentContainerItem}>
                            <div className={Styles.contentContainerItemUpper}>
                                <div className={Styles.contentContainerItemUpperLeft}>
                                    {this._renderText("item_19")}
                                </div>
                                <div className={Styles.contentContainerItemUpperRight}>
                                   {this.state.lockin > 1 && this.state.campaign_fee &&<span className={Styles.lockin}>{this.state.lockin}{" "}X{" "}</span>}
                                    {this.state.duration}{" "}{this._renderText("item_20")}
                                </div>
                            </div>
                        </div>
                        <div className={Styles.dividerSmall}/>
                        <div className={Styles.contentContainer}>
                            {
                                Object.keys(this.state.channels).map((key, i) => {
                                    return (
                                        <div key={i} className={Styles.contentContainerItem}>
                                            <div className={Styles.contentContainerItemUpper}>
                                                <div className={Styles.contentContainerItemUpperLeft}>
                                                    {this._renderChannel(key).toUpperCase()}
                                                </div>
                                                <div className={Styles.contentContainerItemUpperRight}>
                                                    {this.state.lockin > 1 && this.state.campaign_fee &&<span className={Styles.lockin}>{this.state.lockin}{" "}X{" "}</span>}
                                                    {this._renderNumbers(Math.round(this.state.channels[key]))}{" "}{this.state.currency.toUpperCase()}
                                                </div>
                                            </div>
                                            <div className={Styles.contentContainerItemLower}>
                                                <div className={Styles.contentContainerItemLowerLeft}>
                                                    {Math.floor(this.state.channels[key] / this.state.duration)}{" "}{this.state.currency.toLowerCase()}{" "}/{" "}{this._renderText("item_21")}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            {
                                (this.state.service_fee > 0) &&
                                <div className={Styles.contentContainerItem}>
                                    <div className={Styles.contentContainerItemUpper}>
                                        <div className={Styles.contentContainerItemUpperLeft}>
                                            {this._renderText("item_15").toUpperCase()}
                                        </div>
                                        {
                                            this.state.service_fee &&
                                            <div className={Styles.contentContainerItemUpperRight}>
                                                {this._renderNumbers(Math.round(this.state.service_fee))}{" "}{this.state.currency.toUpperCase()}
                                            </div>
                                        }
                                    </div>
                                    <div className={Styles.contentContainerItemLower}>
                                        <div className={Styles.contentContainerItemLowerLeftService}>
                                            {
                                                this.state.lockin > 1 &&
                                                <span>{this._renderText("item_24")}{" "}{this.state.lockin}</span>
                                            }
                                            {
                                                this.state.lockin < 2 &&
                                                <span>{this._renderText("item_26")}</span>
                                            }
                                        </div>
                                        {
                                            false &&
                                            <div className={Styles.contentContainerItemLowerRightService}>
                                                {
                                                    this.state.discount > 0 &&
                                                    <span>-{this._renderNumbers(Math.round(this.state.discount))} {this.state.currency.toUpperCase()}</span>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                (this.state.campaign_fee > 0 && this.state.discount > 0) && false &&
                                <div className={Styles.contentContainerItem}>
                                    <div className={Styles.contentContainerItemUpper}>
                                        <div className={cx(Styles.contentContainerItemUpperLeft, Styles.contentContainerItemUpperRightGreen)}>
                                            {this._renderText("item_25").toUpperCase()}
                                        </div>
                                        <div className={cx(Styles.contentContainerItemUpperRight, Styles.contentContainerItemUpperRightGreen)}>
                                            <span>-{this._renderNumbers(Math.round(this.state.discount))} {this.state.currency.toUpperCase()}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                (this.state.excess_credits || this.state.discount) &&
                                <div className={Styles.contentContainerItem}>
                                    <div className={Styles.contentContainerItemUpper}>
                                        <div
                                            className={cx(Styles.contentContainerItemUpperLeft, Styles.contentContainerItemUpperRightGreen)}>
                                            {this._renderText("item_25").toUpperCase()}
                                        </div>
                                        <div
                                            className={cx(Styles.contentContainerItemUpperRight, Styles.contentContainerItemUpperRightGreen)}>
                                            <span>-</span>{this._renderNumbers(Math.round(this._renderDiscount()))}{" "}{this.state.currency.toUpperCase()}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className={Styles.dividerSmall}/>
                        <div className={Styles.vatContainer}>
                            <div className={Styles.vatContainerLeft}>
                                {this._renderText("item_17")}{" "}({+this.state.vat * 100}%)
                            </div>
                            <div className={Styles.vatContainerRight}>
                                {this._renderNumbers(this._renderPartialBudget() * +this.state.vat)}{" "}{this.state.currency.toUpperCase()}
                            </div>
                        </div>
                        <div className={Styles.dividerSmall}/>
                        <div className={Styles.totalContainer}>
                            <div className={Styles.totalContainerLeft}>
                                {this._renderText("item_18")}
                            </div>
                            <div className={Styles.totalContainerRight}>
                                {this._renderNumbers(this._renderPartialBudget() * (+this.state.vat + 1))}{" "}{this.state.currency.toUpperCase()}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

/*
  <div className={Styles.campaignDate}>
                            <Countdown date={30}/>
                        </div>

                            <span>{this._renderText("item_5")}</span><span className={Styles.campaignDateBold}>&nbsp;29{this._renderText("item_6")}&nbsp;:&nbsp;24{this._renderText("item_7")}&nbsp;:&nbsp;59{this._renderText("item_8")}&nbsp;:&nbsp;59{this._renderText("item_9")}</span>&nbsp;{this._renderText("item_10")}

 */

export default SignupConfirmation;


// WEBPACK FOOTER //
// ./src/pages/signup-confirmation/component.js